export default {
  profile: (state) => {
    return state.profile;
  },

  roles: (state) => {
    return state.roles;
  },
  role: (state) => {
    return state.role;
  },
  roleCode: (state) => {
    return state.roleCode;
  },

  rolePermissions: (state) => {
    return state.rolePermissions;
  },

  // User Role Access Management
  userRoles: (state) => {
    const roleOptions = [];
    state.userRoles.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      roleOptions.push(pushItem);
    }
    return roleOptions;
  },

  defaultPermissions: (state) => {
    return state.defaultPermissions;
  },

  reloadNavbar: (state) => {
    return state.reloadNavbar;
  },

  users: (state) => {
    return state.users;
  },
  user: (state) => {
    return state.user;
  },

  persons: (state) => {
    return state.persons;
  },
  personByMobile: (state) => {
    return state.personByMobile;
  },
  personByNationalCode: (state) => {
    return state.personByNationalCode;
  },
};
